/* eslint-disable no-unused-vars */
import React, { useContext, useState, useEffect } from 'react';
import { Row, Col, Form, Input, Button, message, Checkbox } from 'antd';
import { useHistory } from 'react-router-dom';
import './styles.less';
import { InfoCircleOutlined } from '@ant-design/icons';
import InputRut from '../../../../components/form/inputs/InputRut';
import { rutValidator } from '../../../../utils/validators';
import { validateRut } from '../../../../utils/rut';
import NotificationModal from '../../../../components/common/NotificationModal';
import { EnrollmentContext } from '../../../../providers/EnrollmentContextProvider';
import enrollmentAction from '../../../../providers/EnrollmentContextProvider/enrollmentAction';
import InitPage from '../../api-initPage';
import { EnrollmentFormContext } from '../../../../providers/EnrollmentFormContextProvider';
import EnrollmentView from '../../../../enums/EnrollmentView';

const NaturalForm = () => {
  const history = useHistory();
  const [rutIsAlreadyRegistered, setRutIsAlreadyRegistered] = useState();
  const [rutHasEnrollmentFormInProgress, setRutHasEnrollmentFormInProgress] = useState();
  const { dispatch } = useContext(EnrollmentContext);
  const { enrollmentForm } = useContext(EnrollmentFormContext);
  const [checkedTerms, setCheckedTerms] = useState(false);

  const fetchRutStatus = () => {
    if (validateRut(enrollmentForm.getFieldValue(['person', 'rut']) || '')) {
      InitPage.rutStatus(
        enrollmentForm.getFieldValue(['person', 'rut'])?.replace(/\./g, '').replace(/-/g, '')
      )
        .then((response) => {
          setRutIsAlreadyRegistered(response.data.isAlreadyRegistered);
          setRutHasEnrollmentFormInProgress(response.data.hasEnrollmentFormInProgress);
          enrollmentForm.setFieldsValue({ name: response.data.legalPersonName });
        })
        .catch(() => message.error('Error inesperado. Por favor, intente nuevamente.'));
    }
  };
  const allowLettersAndWS = RegExp(
    '^(s*[a-zA-ZáéíóúAÁÉÍÓÚäëïöüÄËÏÖÜ\u00f1\u00d1]*)+(s*[a-zA-ZáéíóúAÁÉÍÓÚäëïöüÄËÏÖÜ\u00f1\u00d1]*)*[a-zA-ZáéíóúAÁÉÍÓÚäëïöüÄËÏÖÜ\u00f1\u00d1 ]*$'
  );
  const handleButtonNext = () => {
    if (!rutIsAlreadyRegistered && !rutHasEnrollmentFormInProgress) {
      dispatch({
        type: enrollmentAction.GO_TO_VIEW,
        payload: EnrollmentView.StepsForms,
      });
      dispatch({
        type: enrollmentAction.SET_HAS_ACCEPTED_TERMS,
        payload: enrollmentForm.getFieldValue(),
      });
      history.push('/enrolamiento/inicio');
    }
  };

  const handleSubmit = () => {
    handleButtonNext();
  };
  useEffect(() => {
    if (rutIsAlreadyRegistered) {
      NotificationModal(
        <InfoCircleOutlined style={{ color: 'red' }} />,
        'RUT ya registrado',
        'El RUT ingresado ya se encuentra registrado en nuestro sistema.'
      );
    }
  }, [rutIsAlreadyRegistered]);

  useEffect(() => {
    const checked = enrollmentForm.getFieldValue(['person', 'hasAcceptedTerms']);
    if (checked) {
      setCheckedTerms(checked);
      enrollmentForm.setFieldsValue({
        person: { hasAcceptedTerms: checked },
      });
    }
  }, [enrollmentForm.getFieldValue(['person', 'hasAcceptedTerms'])]);

  const handleCheckboxChange = (e) => {
    setCheckedTerms(e.target.checked);
    enrollmentForm.setFieldsValue({ person: { hasAcceptedTerms: e.target.checked } }); // Actualiza el formulario
  };

  return (
    <Row className="naturalForm">
      <Col span={24}>
        <Row>
          <Col offset={4}>
            <p className="naturalForm__title">Persona Natural</p>
          </Col>
        </Row>
        <Form form={enrollmentForm} onFinish={handleSubmit} layout="vertical" requiredMark onc>
          <Row justify="center">
            <Col span={16}>
              <Form.Item
                name={['person', 'rut']}
                label="RUT"
                rules={[
                  {
                    required: true,
                    validator: rutValidator,
                  },
                ]}
                validateTrigger="onBlur"
              >
                <InputRut type="text" maxLength={17} onBlur={fetchRutStatus} />
              </Form.Item>
            </Col>
          </Row>
          <Row justify="center">
            <Col span={16}>
              <Form.Item
                name={['person', 'name']}
                label="Nombres"
                rules={[
                  {
                    required: true,
                    message: 'Nombre  es requerido',
                  },
                  {
                    pattern: allowLettersAndWS,
                    message: 'Ingrese solo letras',
                  },
                ]}
              >
                <Input />
              </Form.Item>
            </Col>
          </Row>
          <Row justify="center">
            <Col span={16}>
              <Form.Item
                name={['person', 'firstSurname']}
                label="Apellido Paterno"
                rules={[
                  {
                    required: true,
                    message: 'Apellido es requerido',
                  },
                  {
                    pattern: allowLettersAndWS,
                    message: 'ingrese solo letras',
                  },
                ]}
              >
                <Input />
              </Form.Item>
            </Col>
          </Row>
          <Row justify="center">
            <Col span={16}>
              <Form.Item
                name={['person', 'secondSurname']}
                label="Apellido Materno"
                rules={[
                  {
                    required: true,
                    message: 'Apellido es requerido',
                  },
                  {
                    pattern: allowLettersAndWS,
                    message: 'ingrese solo letras',
                  },
                ]}
              >
                <Input />
              </Form.Item>
            </Col>
          </Row>
          <Row justify="center">
            <Col span={16}>
              <Form.Item
                name={['person', 'email']}
                label="E-mail"
                rules={[
                  {
                    required: true,
                    type: 'email',
                    message: 'email es requerido',
                  },
                ]}
              >
                <Input />
              </Form.Item>
            </Col>
          </Row>
          <Row justify="center">
            <Col span={16}>
              <Form.Item
                name={['person', 'hasAcceptedTerms']}
                valuePropName="checked"
                preserve
                rules={[
                  {
                    validator: (_, value) =>
                      value
                        ? Promise.resolve()
                        : Promise.reject(new Error('Terminos de aceptación es requerido')),
                  },
                ]}
              >
                <Row className="row-content-aceptTerm">
                  <Col>
                    <span className="required">*</span>
                  </Col>
                  <Col>
                    <Checkbox checked={checkedTerms} onChange={handleCheckboxChange}>
                      Acepto expresamente el uso y tratamiento de los datos proporcionados, para
                      fines comerciales, estadísticos e informativos propios de los
                      productos/servicios de Vantrust Capital y/o sus empresas relacionadas.
                    </Checkbox>
                  </Col>
                </Row>
              </Form.Item>
              
            </Col>
          </Row>
          <Row justify="center">
            <Col span={16}>
              <Button className="naturalForm__button" type="primary" htmlType="submit">
                Comenzar
              </Button>
            </Col>
          </Row>
        </Form>
      </Col>
    </Row>
  );
};

export default NaturalForm;
